{
  "applications": {
    "all_up": "Öll fáanleg",
    "applications": "Forrit",
    "instances": "Eintök",
    "some_down": "Eintök ekki fáanleg",
    "last_update": "Síðasta uppfærsla",
    "loading_applications": "Forrit eru að ræsa…",
    "no_applications_registered": "Engin forrit skráð.",
    "notifications_suppressed_for": "Tilkynningar fyrir <code>{name}</code> eru hunsuð fyrir",
    "restricted": "skert",
    "server_connection_failed": "Mistókst sambandið við þjón.",
    "suppress_notifications_on": "Tilkynningar fyrir <code>{name}</code> fyrir",
    "status": "Staða",
    "label": "Forrit",
    "up": "OK",
    "shutdown": "Shutdown application <code>{name}</code>?",
    "restart": "Restart application <code>{name}</code>?",
    "restarted": "Successfully restarted application <code>{name}</code>"
  },
  "instances": {
    "shutdown": "Shutdown instance <code>{name}</code>?",
    "open_details": "Opna upplýsingar um eintak",
    "restart": "Restart instance <code>{name}</code>?",
    "restarted": "Successfully restarted instance"
  }
}
